module.exports = __webpack_public_path__ + "static/media/date-onclick.f204cea3.svg";